// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-recepty-js": () => import("/opt/build/repo/src/templates/recepty.js" /* webpackChunkName: "component---src-templates-recepty-js" */),
  "component---src-templates-tags-js": () => import("/opt/build/repo/src/templates/tags.js" /* webpackChunkName: "component---src-templates-tags-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kontakt-js": () => import("/opt/build/repo/src/pages/kontakt.js" /* webpackChunkName: "component---src-pages-kontakt-js" */),
  "component---src-pages-tags-js": () => import("/opt/build/repo/src/pages/tags.js" /* webpackChunkName: "component---src-pages-tags-js" */),
  "component---src-pages-tools-js": () => import("/opt/build/repo/src/pages/tools.js" /* webpackChunkName: "component---src-pages-tools-js" */)
}

